module.exports = __webpack_public_path__ + "media/assets/artaround-logo-c9b330654800b33af935333762c11d03.png";